import $ from 'jquery';
import lozad from 'lozad'

window.addEventListener('load', function() {

  var courses_list = document.querySelector('.js-courses-list');

  if(!courses_list)
    return;

  window.paged = 1;
  var maxnumpages = document.querySelector('.js-courses-list-item').getAttribute('data-maxnumpages');
  var select_sector = document.querySelector('.js-select-sector');
  var select_location = document.querySelector('.js-select-location');
  var filterSubmit = document.querySelector('.js-filter-submit');
  var loadMoreButton = document.querySelector('.js-load-more');
  var sectorSlug = 'filiere';
  var locationSlug = 'localisation';
  var current_sector = getUrlParameter(sectorSlug) ? getUrlParameter(sectorSlug)  : select_sector.options[select_sector.selectedIndex].value;
  var current_location = getUrlParameter(locationSlug) ? getUrlParameter(locationSlug) : select_location.options[select_location.selectedIndex].value;
  const observer = lozad();

  // On filters change, empty List & load a new List
  filterSubmit.addEventListener('click', function(){

    // Disabled during ajax load
    if(filterSubmit.classList.contains('disabled'))
      return;

    current_sector = select_sector.options[select_sector.selectedIndex].value;
    current_location = select_location.options[select_location.selectedIndex].value;
    courses_list.classList.add('loading');
    window.paged = 1;
    loadMoreButton.style.display = "none";

    // courses_list.innerHTML = '';
    // rewriteURL();
    // loadCourses();
  });

  // On Load More Click, increment paged & load Courses
  loadMoreButton.addEventListener('click', function(){

    // Disabled during ajax load
    if(loadMoreButton.classList.contains('disabled'))
      return;

    window.paged++;

    loadCourses();
  });

  // Show previous Page & Load hidden next Page with filters
  function loadCourses(){

    // Disable filterSubmit & loadMoreButton during ajax load
    filterSubmit.classList.add('disabled');
    loadMoreButton.classList.add('disabled');

    // Ajax Post
    $.ajax({
      cache: true,
      url: ajax_js.ajaxurl,
      type: 'get',
      data: {
        action: 'load_courses',
        paged: window.paged,
        sector: current_sector,
        location: current_location,
      },
      success: function(html) {
        if(html){

          // Add page results to list
          courses_list.innerHTML += html;

          // Lazy Load Observer
          observer.observe();

          // On 1st page, set maxnumpage
          if(window.paged == 1)
            maxnumpages = document.querySelector('.js-courses-list-item').getAttribute('data-maxnumpages');

          // Hide loadMoreButton & break function when there's no more Page to load
          if(window.paged >= maxnumpages){
            loadMoreButton.style.display = 'none';
            return;
          } else{
            loadMoreButton.style.display = 'block';
          }

          // Enable filterSubmit & loadMoreButton after ajax load
          filterSubmit.classList.remove('disabled');
          loadMoreButton.classList.remove('disabled');
        }
      }
    });
  }


  // Rewrite current page URL according to current filters
  function rewriteURL() {

    var parametersArray = [];
    var parametersSlug = location.protocol + '//' + location.host + location.pathname;

    if(current_sector != '' && current_sector != 'all')
      parametersArray.push({
        'slug' : sectorSlug,
        'filter' : current_sector
      });
    if(current_location != '' && current_location != 'all')
      parametersArray.push({
        'slug' : locationSlug,
        'filter' : current_location
      });

    for (let index = 0; index < parametersArray.length; index++) {
      if(index == 0)
        parametersSlug += '?';
      else
        parametersSlug += '&';

      parametersSlug += parametersArray[index]['slug'] + "=" + parametersArray[index]['filter'];
    }

    window.history.pushState("", "", parametersSlug);
  }

  // Get parameter value from an URL parameter key
  function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam)
        return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }

});
